import React from 'react';

const BInputError = ({ errors }) => {
  return errors && <p className={'text-sm text-red-600'}>{errors.message}</p>;
};

export default BInputError;
